const REMOVABLE_RELATIONS = new Set(['editor', 'viewer'])

export const isInheritedAccess = (item) => item?.inherited === true || item?.inherited === 'true'
export const isRemovableAccess = (item) => REMOVABLE_RELATIONS.has(item?.relation) && !isInheritedAccess(item)

export const ACCESS_LEVELS = {
  viewer: 1,
  editor: 2,
  owner: 3,
}

export const ASSIGNABLE_RELATION = 'editor'
export const MIN_EXCLUDED_LEVEL = ACCESS_LEVELS[ASSIGNABLE_RELATION]
export const buildDirectAccessKey = (item) => `${item?.id}:${item?.relation}`

export const buildDraftAccessData = (initialAccessData = [], draftAddedAccess = [], draftRemovedAccessKeys = []) => {
  const removedKeys = new Set(draftRemovedAccessKeys)
  const directAccessUserIds = new Set(draftAddedAccess.map((item) => String(item?.id)))

  const remainingInitialAccess = initialAccessData.filter((item) => {
    if (!isRemovableAccess(item)) {
      return true
    }

    return !removedKeys.has(buildDirectAccessKey(item))
  })

  const visibleInitialAccess = remainingInitialAccess.filter((item) => {
    if (!isInheritedAccess(item)) {
      return true
    }

    return !directAccessUserIds.has(String(item?.id))
  })

  return [...visibleInitialAccess, ...draftAddedAccess]
}

export const buildAccessChangeSet = (initialAccessData = [], draftAddedAccess = [], draftRemovedAccessKeys = []) => {
  const removedKeys = new Set(draftRemovedAccessKeys)

  return {
    additions: draftAddedAccess,
    deletions: initialAccessData.filter((item) => isRemovableAccess(item) && removedKeys.has(buildDirectAccessKey(item))),
  }
}
